module.exports = __webpack_public_path__ + "img/unbarring.df446cb6.jpg";